import React from 'react'

export default function OthersMain() {
  return (
    <div> ** Constructing **</div>
  )
}
